module.exports = __webpack_public_path__ + "static/media/credit_card.85901924.svg";